import { CLienteAPi } from "../../client_api";

export interface PermisoTipoUsuarioItem {
  AplicacionId: number;
  ModuloId: number;
  AccionId: number;
}

//insUpdTiposUsuario
export class Request_insertion_upd_userTypes {
  ConexionIacpos: number;
  clienteAPI: CLienteAPi;
  pkId: string;
  Nombre: string;
  Descripcion: string;
  Privilegios: string;
  Funcion: string;
  CentrosIds: string;
  idTyp: string;
  /** Lista de permisos (solo acciones activas). Usado con GestionPermisos: 1 */
  Permisos?: PermisoTipoUsuarioItem[];
  GestionPermisos?: number;
  ConexionId?: string;
}